import React, { PureComponent } from 'react'
import styled from 'styled-components';
import GlobalStyle from 'stylecomponents/globalstyle';
import ActivityItem from 'components/commons/ActivityItem';
import PaginationView from 'components/commons/pagination/PaginationView';
import ListHeader from 'components/news/ListHeader';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import convetDBResultSetToArray from "actions/util/convetDBResultSetToArray";
import moment from 'moment';
/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
const FILTER_DATE_TYPE = {
  ALL: 'all',
  THREE_DAY: 'three_day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year'
};

const TIME_SEC = {
  [FILTER_DATE_TYPE.THREE_DAY]: 259200000,
  [FILTER_DATE_TYPE.WEEK]: 604800000,
  [FILTER_DATE_TYPE.MONTH]: 2678400000,
  [FILTER_DATE_TYPE.YEAR]: 31536000000,
};

/**
|--------------------------------------------------
| Styled
|--------------------------------------------------
*/
const Container = GlobalStyle.BasicBlock.extend`
  grid-column: 1/2;
  grid-row: 1/-1;
`

const ListFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0;
`

class NewsList extends PureComponent {

  constructor(props) {
    super(props);

    this.fetchNewsBulletins = this.fetchNewsBulletins.bind(this);
    
    const routerState = CupoyRouter.getCurrent();
    const { querys } = routerState;
    const { bclass } = querys;

    this.state = {
      bclass,
      limit: 15,
      total: null,
      maxPageNum: null,
      start: 0,
      currentPage: 0,
      newsList: [],
      startdate: null,
      enddate: null,
      filterDate: FILTER_DATE_TYPE.ALL,
      isEmpty: false,
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });
    
    this.fetchNewsBulletins(true);
  }

  fetchNewsBulletins(init) {

    const {
      bclass,
      limit,
      start,
      startdate,
      enddate,
    } = this.state;

    this.props.bulletinActions.listBulletins({
        bclass,
        len: limit,
        start: start,
        startdate,
        enddate,
    }).then((result = {}) => {

      const {
        totalResultSize = 0,
        resultSize = 0,
      } = result;

      const dbResult = convetDBResultSetToArray(result) || [];
      const newsList = dbResult.map(({ bulletinid } = {}) => bulletinid);

      if(init) 
        this.setState({
          total: totalResultSize,
          maxPageNum: Math.ceil(totalResultSize / this.state.limit),
          currentPage: 1,
          start: resultSize,
          newsList,
          isEmpty: resultSize === 0,
        });
      else 
        this.setState({
          newsList,
          isEmpty: resultSize === 0,
        });
    });
  }

  changePage = (num, nextStart) => {
    this.setState({
      currentPage: num,
      start: nextStart,
    }, this.scrollTop);
  }

  changePageToNext = () => {

    const { currentPage, maxPageNum, limit } = this.state;

    if((currentPage + 1) > maxPageNum) return;

    this.setState(prevState => ({
      currentPage: +prevState.currentPage + 1,
      start: ((+prevState.currentPage + 1) -1 ) * limit,
    }), this.scrollTop);
  }

  changePageToPrev = () => {

    const { currentPage, limit } = this.state;

    if((currentPage - 1) < 1) return;

    this.setState(prevState => ({
      currentPage: +prevState.currentPage - 1,
      start: ((+prevState.currentPage - 1) - 1) * limit,
    }), this.scrollTop);
  }

  scrollTop = init => {
    window.scrollTo({ top: 0 });
    this.fetchNewsBulletins(init);
  }

  changeDate = date => {

    if(!date) {

      this.setState({
        startdate: null,
        enddate: null,
        filterDate: FILTER_DATE_TYPE.ALL,
        start: 0,
      }, () => this.scrollTop(true));

      return;
    }

    const enddate = moment(Date.now()).format('YYYYMMDDhhmmss');
    
    let startdate = new Date().setHours(0, 0, 0, 0);

    switch (date) {
      case FILTER_DATE_TYPE.THREE_DAY:
        startdate = startdate - TIME_SEC[FILTER_DATE_TYPE.THREE_DAY];
        break;
      case FILTER_DATE_TYPE.WEEK:
        startdate = startdate - TIME_SEC[FILTER_DATE_TYPE.WEEK];
        break;
      case FILTER_DATE_TYPE.MONTH:
        startdate = startdate - TIME_SEC[FILTER_DATE_TYPE.MONTH];
        break;
      case FILTER_DATE_TYPE.YEAR:
        startdate = startdate - TIME_SEC[FILTER_DATE_TYPE.YEAR];
        break;
      default:
        break;
    }

    startdate = moment(startdate).format('YYYYMMDD');

    if(startdate)
      this.setState({
        startdate,
        enddate,
        filterDate: date,
        start: 0,
      }, () => this.scrollTop(true));
  }

  render() {

    const {
      // bclass,
      total,
      currentPage,
      newsList,
      filterDate,
      isEmpty,
    } = this.state;

    const {
      // idsbyclass = [],
      itemMap,
      isloading,
    } = this.props;

    return (
      <Container>
        <ListHeader
          changeDate={this.changeDate}
          filterDateType={FILTER_DATE_TYPE}
          filterDate={filterDate}
        />
        {
          !isloading && newsList.map((bulletinid, index) => {

            if(index >= this.state.limit) return null;

            const bulletin = itemMap[bulletinid];

            const {
              title = '',
              publishtime,
              topbulletin,
            } = bulletin;

            return (
              <ActivityItem
                key={bulletinid}
                stateName={CupoyRouter.STATES.NEWS}
                title={title.trim()}
                time={publishtime}
                bulletinid={bulletinid}
                topbulletin={topbulletin}
              />
            );
          })
        }
        {
          isloading && (
            <GlobalStyle.LoadingContainer>
                <GlobalStyle.Spin />
            </GlobalStyle.LoadingContainer>
          )
        }
        {
          isEmpty && !isloading && (
            <GlobalStyle.ErrorContainer>
              <GlobalStyle.ErrorContainerTitle>
                查無資料
              </GlobalStyle.ErrorContainerTitle>
              <GlobalStyle.ErrorContainerDesription>
                沒有任何新聞
              </GlobalStyle.ErrorContainerDesription>
            </GlobalStyle.ErrorContainer>
          )
        }
        {
          (currentPage > 0) && (total > 0) && (
            <ListFooter>
              <PaginationView
                total={total}
                limit={this.state.limit}
                changePage={this.changePage}
                nowPage={currentPage}
                changePageToNext={this.changePageToNext}
                changePageToPrev={this.changePageToPrev}
              />
            </ListFooter>
          )
        }
      </Container>
    )
  }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
      itemMap: state.bulletin.itemMap,
      idsbyclass: state.bulletin.idsbyclass,
      isloading: state.bulletin.isloading,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    bulletinActions: bindActionCreators(actionCreators.bulletinActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(NewsList);
